// extracted by mini-css-extract-plugin
module.exports = {"worksContainer":"styles_worksContainer__YRvg3","showMoreButton":"styles_showMoreButton__6ZK_G"};